import { Link, useRouterState } from '@tanstack/react-router';

/**
 * Segmented control for switching between the Grid view (default,
 * AG-Grid-backed work-order table) and the Timeline view (Gantt-style
 * planner, currently a blank-slate placeholder). The toggle is declared once
 * on the `/production-planner` layout route's `headerActions` and rendered
 * for both the Grid and Timeline children, so it derives the active view
 * from the current route rather than requiring the render site to pass it in.
 */
export function ProductionPlannerViewToggle() {
  const pathname = useRouterState({ select: (state) => state.location.pathname });
  const resolvedView = pathname === '/production-planner/timeline' ? 'timeline' : 'grid';

  return (
    <nav
      aria-label="Production planner view"
      className="bg-muted inline-flex items-center gap-0.5 rounded-md p-0.5"
    >
      <Link
        to="/production-planner"
        className={`rounded-sm px-3 py-1 text-sm transition-colors ${
          resolvedView === 'grid'
            ? 'bg-background text-foreground shadow-sm'
            : 'text-muted-foreground hover:text-foreground'
        }`}
        aria-current={resolvedView === 'grid' ? 'page' : undefined}
      >
        Grid
      </Link>
      <Link
        to="/production-planner/timeline"
        className={`rounded-sm px-3 py-1 text-sm transition-colors ${
          resolvedView === 'timeline'
            ? 'bg-background text-foreground shadow-sm'
            : 'text-muted-foreground hover:text-foreground'
        }`}
        aria-current={resolvedView === 'timeline' ? 'page' : undefined}
      >
        Timeline
      </Link>
    </nav>
  );
}
